import React, { useState } from 'react';
import ReferralCode from './ReferralCode';
import { FaEdit, FaSave } from 'react-icons/fa';

const SettingsPage = ({ userDetails }) => {
  const [showReferralCode, setShowReferralCode] = useState(false);
  const [editing, setEditing] = useState(false);
  const [username, setUsername] = useState(userDetails.username || '');
  const [saveStatus, setSaveStatus] = useState('');

  const toggleReferralCode = () => setShowReferralCode(prev => !prev);

  const saveUsername = async () => {
    if (!username.trim()) return;

    try {
      const response = await fetch('https://www.sharedvision-partners.online/v1/API/update_username.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: userDetails.email, username }),
      });

      const result = await response.json();

      if (result.success) {
        setSaveStatus('Username updated successfully!');
        setEditing(false); // lock the field after success
      } else {
        setSaveStatus(result.message || 'Failed to update username');
      }
    } catch (error) {
      console.error('Error updating username:', error);
      setSaveStatus('Network error. Try again later.');
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: 'auto', padding: '20px' }}>
      <h2>Settings</h2>
      <p>Configure your preferences here.</p>
      <p>Make changes to your account settings here, we are adding more features.</p>

      {/* Username Edit Field */}
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px', marginBottom: '10px' }}>
        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Username:</label>
        <input
          type="text"
          value={username}
          readOnly={!editing}
          onChange={(e) => setUsername(e.target.value)}
          style={{
            padding: '8px',
            fontSize: '16px',
            width: '250px',
            border: editing ? '2px solid #007bff' : '1px solid #ccc',
            borderRadius: '5px',
            backgroundColor: editing ? '#fff' : '#f5f5f5',
            marginRight: '10px',
          }}
        />
        {!editing ? (
          <button
            onClick={() => setEditing(true)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#007bff' }}
            title="Edit Username"
          >
          <FaEdit size={40} />  {/* Increased icon size here */}
          </button>
        ) : (
          <button
            onClick={saveUsername}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'green' }}
            title="Save Username"
          >
            <FaSave size ={40}/>
          </button>
        )}
      </div>

      {/* Status message */}
      {saveStatus && (
        <div style={{ marginTop: '5px', fontSize: '14px', color: 'green' }}>
          {saveStatus}
        </div>
      )}

      {/* Toggle Referral Code */}
      <button
        onClick={toggleReferralCode}
        style={{
          marginTop: '20px',
          padding: '8px 16px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        {showReferralCode ? 'Hide Referral Code' : 'Show Referral Code'}
      </button>

      {showReferralCode && <ReferralCode userDetails={userDetails} />}
    </div>
  );
};

export default SettingsPage;
